import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import StudentProfile from "Assets/Images/StudentProfile.svg";
import { ProgramActionCode } from "utilFunctions/Constants/Constants";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
const NameDiv = styled<any>("div")`
    font-size ${(props: any) =>
      ["xxl", "xl", "g"].includes(props.screen)
        ? props.mode && props.mode == "attendance"
          ? "16px"
          : "20px"
        : "14px"};
    color: ${(props: any) => (props.isEnabled ? "#333" : "#00B0F5")};
    cursor: ${(props: any) =>
      props.mode && props.mode == "attendance" ? "pointer" : "auto"};
    font-style: normal;
    font-weight: 600;
`;
const BasicInfoDiv = styled<any>("div")`
      font-size ${(props: any) =>
        ["xxl", "xl", "lg"].includes(props.screen)
          ? props.mode && props.mode == "attendance"
            ? "14px"
            : "16px"
          : "12px"};
      color: var(--Grey-60, #757575);
      font-style: normal;
      font-weight: 400;
      padding-top: ${(props: any) => (props.isTop ? "4px" : "0px")};
`;
const BasicInfoDiv2 = styled<any>("div")`
padding-top: ${(props: any) =>
  ["xxl", "xl", "lg"].includes(props.screen) ? "8px" : "8px"};
      display:flex;
      flex-direction ${(props: any) =>
        ["xxl", "xl", "lg"].includes(props.screen) ? "column" : "column"};
`;
const ProfileImageDiv = styled<any>("div")`
      display:flex;
      flex-direction: column;
      padding-right ${(props: any) =>
        ["xxl", "xl", "lg"].includes(props.screen) ? "16px" : "16px"};
`;
const ActiveProfileTextDiv = styled<any>("div")`
  border-radius: 0px 0px 6.667px 6.667px;
  background: ${(props: any) => (props.isActive ? "#50b47f" : "#E7685A")};
  color: var(--White, #fff);
  text-align: center;
  font-size ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen) ? "14px" : "10px"};
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  height:${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen) ? "24" : "16px"};
  width: ${(props: any) =>
    ["xxl", "xl", "lg"].includes(props.screen)
      ? props.isUrl
        ? "81px"
        : "112px"
      : props.isUrl
      ? "55px"
      : "82px"};
`;
const StudentInformationComponent = ({
  selectedStudent,
  selectStudentDetailHandler,
  mode,
}: any) => {
  const { screen }: any = useWindowSize();
  return (
    <div className="w-100 d-flex h-100">
      {selectedStudent ? (
        <>
          <ProfileImageDiv screen={screen}>
            <img
              className={
                ["xxl", "xl", "lg"].includes(screen)
                  ? "profileImage"
                  : "profileImageMB"
              }
              id="selected-image"
              src={
                mode && mode != "attendance"
                  ? selectedStudent?.photoKey
                  : selectedStudent?.imageUrl
                  ? selectedStudent?.imageUrl
                  : StudentProfile
              }
              onError={(event: any) => {
                event.target.src = StudentProfile;
                event.onerror = null;
              }}
            />

            <ActiveProfileTextDiv
              isUrl={selectedStudent?.imageUrl ? false : true}
              screen={screen}
              isActive={
                ProgramActionCode.includes(selectedStudent.programAction)
                  ? true
                  : false
              }
            >
              {ProgramActionCode.includes(selectedStudent.programAction)
                ? "Active"
                : "Inactive"}
            </ActiveProfileTextDiv>
          </ProfileImageDiv>
          <div className={"p-0 d-flex flex-column justify-content-center"}>
            <NameDiv
              screen={screen}
              mode={mode}
              isEnabled={selectStudentDetailHandler ? false : true}
              onClick={() => {
                selectStudentDetailHandler &&
                  selectStudentDetailHandler(selectedStudent);
              }}
            >
              {mode && mode == "attendance"
                ? selectedStudent?.studentName
                : selectedStudent?.name}
            </NameDiv>
            <BasicInfoDiv2 screen={screen}>
              <BasicInfoDiv screen={screen} isTop={false}>
                {selectedStudent?.stream} | Class:{" "}
                {selectedStudent?.clazz || "NA"}
              </BasicInfoDiv>

              <BasicInfoDiv screen={screen} isTop={true} mode={mode}>
                PSID :{selectedStudent?.psid || "NA"}
              </BasicInfoDiv>
              <BasicInfoDiv screen={screen} isTop={true} mode={mode}>
                Branch: {selectedStudent?.branch || "NA"}
              </BasicInfoDiv>
            </BasicInfoDiv2>
          </div>
        </>
      ) : (
        <div className="mt-4 mb-8 d-flex justify-content-center align-items-center w-100">
          <NoResultFoundSearch
            primaryMessage="Data not found"
            secondaryMessage={
              "Seems like there was an error loading data                  "
            }
          >
            <NoDataFoundIcon />
          </NoResultFoundSearch>
        </div>
      )}
    </div>
  );
};
export default StudentInformationComponent;
